var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgInProgress = function SvgInProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 14 14",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.5,
    stroke: "currentColor"
  })));
};
export default __webpack_public_path__ + "assets/c4c199469716d28e8ca242ec89e9453a.svg";
export { SvgInProgress as ReactComponent };


// WEBPACK FOOTER //
// ./routes/cpm/routes/parkings/components/Status/assets/icons/in_progress.svg